import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('UserEdit', UserEditData);

  UserEditData.$inject = [];

  /* @ngInject */
  function UserEditData() {
    UserEdit.prototype = { setAssignments: setAssignments, setUser: setUser };

    function UserEdit() {}

    return UserEdit;

    /////////////////////

    function setAssignments(assignments) {
      this.assignments = assignments;
    }

    function setUser(user /*: User */) {
      this.user = user;
    }
  }
})();
